import './Skeleton.css'

/* ── Bloc de base ─────────────────────────────────────────────────────────── */
export function SkeletonBlock({ width = '100%', height = 16, radius = 6, className = '' }) {
  return (
    <div
      className={`skeleton-block ${className}`}
      style={{ width, height, borderRadius: radius }}
    />
  )
}

/* ── Carte produit ────────────────────────────────────────────────────────── */
export function SkeletonProductCard() {
  return (
    <div className="skeleton-product-card">
      <SkeletonBlock height={220} radius={10} />
      <div className="skeleton-product-body">
        <SkeletonBlock width="60%" height={12} />
        <SkeletonBlock height={18} />
        <SkeletonBlock width="40%" height={16} />
        <div style={{ display: 'flex', gap: 8, marginTop: 4 }}>
          <SkeletonBlock width="50%" height={36} radius={8} />
          <SkeletonBlock width="36px" height={36} radius={8} />
        </div>
      </div>
    </div>
  )
}

/* ── Grille de cartes produit ─────────────────────────────────────────────── */
export function SkeletonProductGrid({ count = 8 }) {
  return (
    <div className="skeleton-product-grid">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonProductCard key={i} />
      ))}
    </div>
  )
}

/* ── Page détail produit ──────────────────────────────────────────────────── */
export function SkeletonProductDetail() {
  return (
    <div className="skeleton-detail">
      <div className="skeleton-detail-images">
        <SkeletonBlock height={420} radius={12} />
        <div className="skeleton-detail-thumbs">
          {[1,2,3,4].map(i => <SkeletonBlock key={i} height={80} radius={8} />)}
        </div>
      </div>
      <div className="skeleton-detail-info">
        <SkeletonBlock width="30%" height={12} />
        <SkeletonBlock height={32} />
        <SkeletonBlock width="80%" height={24} />
        <SkeletonBlock width="50%" height={20} />
        <SkeletonBlock height={1} />
        <SkeletonBlock height={14} />
        <SkeletonBlock height={14} />
        <SkeletonBlock width="90%" height={14} />
        <SkeletonBlock height={48} radius={10} />
      </div>
    </div>
  )
}

/* ── Ligne de commande ────────────────────────────────────────────────────── */
export function SkeletonOrderRow() {
  return (
    <div className="skeleton-order-row">
      <SkeletonBlock width={48} height={48} radius={8} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <SkeletonBlock width="40%" height={14} />
        <SkeletonBlock width="60%" height={12} />
      </div>
      <SkeletonBlock width={80} height={24} radius={20} />
      <SkeletonBlock width={100} height={14} />
    </div>
  )
}

/* ── Liste de commandes ───────────────────────────────────────────────────── */
export function SkeletonOrderList({ count = 5 }) {
  return (
    <div className="skeleton-order-list">
      {Array.from({ length: count }).map((_, i) => <SkeletonOrderRow key={i} />)}
    </div>
  )
}

/* ── Dashboard admin — stats ──────────────────────────────────────────────── */
export function SkeletonStatCards({ count = 4 }) {
  return (
    <div className="skeleton-stat-grid">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="skeleton-stat-card">
          <SkeletonBlock width="50%" height={12} />
          <SkeletonBlock width="60%" height={32} />
          <SkeletonBlock width="40%" height={12} />
        </div>
      ))}
    </div>
  )
}

/* ── Tableau admin ────────────────────────────────────────────────────────── */
export function SkeletonTable({ rows = 6, cols = 5 }) {
  return (
    <div className="skeleton-table">
      <div className="skeleton-table-head">
        {Array.from({ length: cols }).map((_, i) => (
          <SkeletonBlock key={i} width={`${60 + i * 10}px`} height={12} />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="skeleton-table-row">
          {Array.from({ length: cols }).map((_, c) => (
            <SkeletonBlock key={c} width={c === 0 ? '30%' : c === cols - 1 ? '60px' : '80%'} height={14} />
          ))}
        </div>
      ))}
    </div>
  )
}

/* ── Ligne panier ─────────────────────────────────────────────────────────── */
export function SkeletonCartItem() {
  return (
    <div className="skeleton-cart-item">
      <SkeletonBlock width={80} height={80} radius={8} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
        <SkeletonBlock width="70%" height={14} />
        <SkeletonBlock width="30%" height={18} />
        <SkeletonBlock width="50%" height={32} radius={8} />
      </div>
    </div>
  )
}

/* ── Carte catégorie ──────────────────────────────────────────────────────── */
export function CategoryCardSkeleton() {
  return (
    <div className="skeleton-product-card" style={{ borderRadius: 12, overflow: 'hidden' }}>
      <SkeletonBlock height={140} radius={0} />
      <div className="skeleton-product-body" style={{ padding: '12px 14px', gap: 8 }}>
        <SkeletonBlock width="55%" height={14} />
        <SkeletonBlock width="30%" height={11} />
      </div>
    </div>
  )
}

/* -- Alias attendus par les composants existants --------------------------- */
export function ProductCardSkeleton() { return <SkeletonProductCard /> }
